import React, { useState, useEffect } from "react";
import { DashboardLayout } from "../../components/layout";

import LocationSelector from "../../components/dashboard/LocationSelector";
// import OfferFilters from "../../components/dashboard/OfferFilters";
// import OffersTable from "../../components/dashboard/OffersTable";
import GstWarning from "../../components/dashboard/GstWarning";
import BannerCards from "../../components/dashboard/BannerCards";
import NewsSlider from "../../components/dashboard/NewsSlider";
import BottomBanner from "../../components/dashboard/BottomBanner";
import InquirySection from "../../components/dashboard/InquirySection";
import FloatingCallButton from "../../components/dashboard/FloatingCallButton";
import DashboardStats from "../../components/dashboard/DashboardStats.jsx";
import LocationInventory from "../../components/dashboard/LocationInventory.jsx";
import { getFCMToken } from "../../utils/getfcmtoken.js";
import { requestLocationPermission } from "../../utils/location.js";
import { onMessage } from "firebase/messaging";
import { messaging } from "../../config/firebase.js";
import { loadDashboardForRole } from "../../services/dashboardService";
import { ROLES, ROLE_LABELS } from "../../config/roles";
import { getRole } from "../../auth/roleService";

const Dashboard = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const [dashboardView, setDashboardView] = useState(() => ({
    role: String(getRole() || ROLES.SELLER).toLowerCase(),
    statItems: [],
    inventory: [],
    raw: {},
    error: null
  }));

  useEffect(() => {
    loadDashboard();
  }, []);

  useEffect(() => {
    // 🔔 FCM
    const token = localStorage.getItem("fcmToken");

    if (!token) {
      getFCMToken().then((token) => {
        if (token) {
          localStorage.setItem("fcmToken", token);
        }
      });
    }

    // 📍 Location
    const alreadyAsked = localStorage.getItem("locationAsked");

    if (!alreadyAsked) {
      requestLocationPermission()
        .then((location) => {
          console.log("📍 Dashboard location:", location);
          localStorage.setItem("locationAsked", "true");
        })
        .catch((err) => {
          console.warn("Location denied:", err);
        });
    }

  }, []);


  useEffect(() => {
    onMessage(messaging, (payload) => {
      console.log("📩 Foreground message:", payload);

      new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: "/logo192.png"
      });
    });
  }, []);
  const roleKey = String(getRole() || ROLES.SELLER).toLowerCase();
  const roleLabel = ROLE_LABELS[roleKey] || "Dashboard";

  const breadcrumbs = [
    { label: roleLabel, link: "/dashboard" },
    { label: "Dashboard" }
  ];

  const loadDashboard = async () => {
    const vm = await loadDashboardForRole();
    setDashboardView(vm);
  };

  const isSeller = dashboardView.role === ROLES.SELLER;

  return (
    <DashboardLayout
      breadcrumbs={breadcrumbs}
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
    >
      {dashboardView.error && (
        <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mb-3">
          Could not load dashboard data for {roleLabel}. Showing empty stats until the API is available.
        </p>
      )}

      <DashboardStats stats={dashboardView.statItems} />

      {isSeller && <LocationInventory data={dashboardView.inventory} />}

      {isSeller && <LocationSelector />}

      {/* <OfferFilters /> */}

      {/* <OffersTable /> */}

      {isSeller && <GstWarning />}

      {isSeller && <BannerCards />}

      {isSeller && <NewsSlider />}

      {isSeller && <BottomBanner />}

      {isSeller && <InquirySection />}

      {isSeller && <FloatingCallButton />}

    </DashboardLayout>
  );
};

export default Dashboard;